import { useConfig } from "../../../../data/useConfig";
import {
  SuggestionContainer,
  SuggestionDefaultItem,
  SuggestionSearchIcon,
} from "../styles";

const DefaultTemplate = ({
  onSearchValue,
  onSuggestionClick,
  onHistorySearch,
  suggestedTerms,
}) => {
  const { useRedirectSuggestions } = useConfig();

  const termsToSearch = suggestedTerms.filter(
    ({ action }) => action === "suggest"
  );

  const termsToRedirect = suggestedTerms.filter(
    ({ action }) => action === "redirect"
  );

  const termsToAnchor = suggestedTerms.filter(
    ({ action }) => action === "anchor"
  );

  const termsToSpecialRedirect = suggestedTerms.filter(
    ({ action }) => action === "url"
  );

  const historyTerms = suggestedTerms.filter(
    ({ action }) => action === "history"
  );

  return (
    <>
      {historyTerms.length > 0 && (
        <SuggestionContainer role="listbox">
          {historyTerms.map(({ label, type, url }) => (
            <SuggestionDefaultItem
              key={crypto.randomUUID()}
              role="option"
              onClick={() => onHistorySearch({ label, type, url })}
              className="bn-search__autocomplete-default-item bn-search__autocomplete-history-item"
            >
              <SuggestionSearchIcon type="button" />
              <span>{label}</span>
            </SuggestionDefaultItem>
          ))}
        </SuggestionContainer>
      )}

      {termsToSpecialRedirect.length > 0 && useRedirectSuggestions && (
        <SuggestionContainer role="listbox">
          {termsToSpecialRedirect.map(({ action, label, target, url }) => (
            <SuggestionDefaultItem
              key={crypto.randomUUID()}
              role="option"
              onClick={() => onSearchValue({ action, label, target, url })}
              className="bn-search__autocomplete-default-item bn-search__autocomplete-redirect-item"
            >
              <SuggestionSearchIcon type="button" />
              <span>{label}</span>
            </SuggestionDefaultItem>
          ))}
        </SuggestionContainer>
      )}

      {termsToSearch.length > 0 && (
        <SuggestionContainer role="listbox">
          {termsToSearch.map(({ action, label, params, type, value }) => (
            <SuggestionDefaultItem
              key={crypto.randomUUID()}
              role="option"
              onClick={() => onSearchValue({ action, label, type, value })}
              className="bn-search__autocomplete-default-item bn-search__autocomplete-search-item"
            >
              <SuggestionSearchIcon type="button" />
              <span>{label}</span>
            </SuggestionDefaultItem>
          ))}
        </SuggestionContainer>
      )}

      {termsToAnchor.length > 0 && (
        <SuggestionContainer role="listbox">
          {termsToAnchor.map(({ action, label, params, type, value }) => (
            <SuggestionDefaultItem
              key={crypto.randomUUID()}
              role="option"
              onClick={() => onSearchValue({ action, label, type, value })}
              className="bn-search__autocomplete-default-item bn-search__autocomplete-anchor-item"
            >
              <SuggestionSearchIcon type="button" />
              <span>{label}</span>
            </SuggestionDefaultItem>
          ))}
        </SuggestionContainer>
      )}

      {termsToRedirect.length > 0 && (
        <SuggestionContainer role="listbox">
          {termsToRedirect.map(({ highlights, label, params, value }) => (
            <SuggestionDefaultItem
              className="bn-search__autocomplete-default-item"
              key={crypto.randomUUID()}
              role="option"
              onClick={() => onSuggestionClick({ label, params, value })}
              data-product-id={`${params.product_id}`}
              data-product-sku={`${params.sku}`}
            >
              <SuggestionSearchIcon type="button" />

              <span>
                {highlights?.map(([type, value]) =>
                  type === "hit" ? (
                    <strong key={crypto.randomUUID()}>{value}</strong>
                  ) : (
                    value
                  )
                )}
              </span>
            </SuggestionDefaultItem>
          ))}
        </SuggestionContainer>
      )}
    </>
  );
};

export default DefaultTemplate;
